@for (option of options; track option) {
  <label
    [class]="getClassListForItem(option)"
    >
    <input
      class="op-option-list--input"
      type="radio"
      [attr.name]="name"
      [value]="option.value"
      [(ngModel)]="selected"
      [disabled]="option.disabled"
      />
    <div>
      <p class="op-option-list--item-title">{{ option.title }}</p>
      @if (option.description) {
        <p
          class="op-option-list--item-description"
          [innerHTML]="option.description"
        ></p>
      }
    </div>
  </label>
}
